import type { RapportStatus } from '@arbeitsrapporte/shared';
import { STATUS_TEXT } from '../format';

/**
 * Die Farbe sagt, wo der Rapport steht: Entwurf grau, abgeschlossen
 * bernstein (wartet auf jemanden), freigegeben und verbucht grün,
 * storniert rot.
 *
 * Gedeckt und nicht kräftig – in einer Liste stehen zwanzig davon
 * untereinander, und die Marke ist eine Auskunft, kein Alarm.
 */
const FARBE: Record<RapportStatus, string> = {
  entwurf: 'border-slate-300 bg-slate-100 text-slate-700',
  abgeschlossen: 'border-amber-300 bg-amber-50 text-amber-800',
  freigegeben: 'border-emerald-300 bg-emerald-50 text-emerald-800',
  verbucht: 'border-emerald-300 bg-emerald-50 text-emerald-800',
  storniert: 'border-rose-300 bg-rose-50 text-rose-900',
};

export function Statusmarke({ status }: { status: RapportStatus }) {
  return (
    <span
      className={`shrink-0 rounded border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${FARBE[status]}`}
    >
      {STATUS_TEXT[status]}
    </span>
  );
}
